import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { push } from 'react-router-redux';
import { isEmpty, get, filter, find, map, compact, keyBy } from 'lodash';
import { formValueSelector, change } from 'redux-form';
import Cookie from 'react-cookie';
import moment from 'moment';
import business from 'moment-business';
import { initAuth } from '../../app-main/actions/auth';
import { Profile } from '../../../../api/api-profile';
import Payments from '../../../../api/api-payments';
import Transactable from 'shared-components/flow-transactable/transactable-main';
import {
  guestUpdateQuote,
  resetContractStore
} from '../../app-main/actions/contracts';
import { fetchInventory } from '../../app-main/actions/inventory';
import { updateProgress, resetProgress } from '../../app-main/actions/flow';
import { GUEST_UPDATE_BOOKING_FORM } from '../../app-bookings-update/guest/forms/constants';
import UpdateBookingGuestMain from '../../app-bookings-update/guest/forms/UpdateBookingGuestMain';
import {
  getInitialScheduleVals,
  normalizeContracts,
  getSelectedAddOns,
  priceBreakdownObject,
  checkCCStateInterval,
  normalizedContractsShape
} from '../../app-bookings-request/forms/bookingUtil';
import { PageSpinner } from 'shared-components/decorators/spinner';
import ProcessingPage from '../../app-bookings-request/ProcessingPage';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { paymentErrors } from '../../app-bookings-current-details/data/payment-data';
import { stripeErrorHandler } from "shared-components/stripe/stripeErrorHandler";
import Contracts from '../../../../api/api-contracts';

class UpdateBookingContainer extends Component {
  constructor (props) {
    super(props);

    this.getCurrentSchedule = this.getCurrentSchedule.bind(this);
    this.getFeeCalc = this.getFeeCalc.bind(this);
    this.handleAttendeesChange = this.handleAttendeesChange.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleAddOnChange = this.handleAddOnChange.bind(this);
    this.handleApplyCreditChange = this.handleApplyCreditChange.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
    this.shapePayload = this.shapePayload.bind(this);
    this.handleListClickCb = this.handleListClickCb.bind(this);
    this.paymentActionFn = this.paymentActionFn.bind(this);
    this.storeCardInstance = this.storeCardInstance.bind(this);
    this.createStripeToken = this.createStripeToken.bind(this);
    this.fetchCardData = this.fetchCardData.bind(this);
    this.submitGuestUpdate = this.submitGuestUpdate.bind(this);
    this.submitCallback = this.submitCallback.bind(this);
    this.ccProcessingCb = this.ccProcessingCb.bind(this);
    this.handleBreadcrumbClick = this.handleBreadcrumbClick.bind(this);
    this.storeCardsData = this.storeCardsData.bind(this);

    this.state = {
      showSkeleton: false,
      paymentInfo: false,
      processing: false,
      errorText: '',
      ccProcessing: false,
      credits: {},
      creditsFetching: false,
      creditsFetched: false,
      applyCreditProcessing: false,
      suggestedCreditAutoCalcCount: 0
    };
  }

  componentDidMount () {
    const { dispatch, routeParams, accessToken, profile, iosBrowseAddOns } = this.props;
    const updateStep = get(routeParams, 'step');
    const bookingId = get(routeParams, 'id') || this.props.bookingID;

    if (accessToken) {
      if (isEmpty(profile.data)) {
        dispatch(initAuth(accessToken));
      }

      Contracts.readContracts(bookingId, accessToken, (contractsRes) => {
        const {
          items,
          bookingObject
        } = normalizeContracts(contractsRes.contracts || []);
        const quotePayload = {
          guest_sso_id: bookingObject.guest_id,
          host_sso_id: bookingObject.host_id,
          items: [
            {
              type: 'BOOKING',
              info: {
                alcohol_consumed: bookingObject.alcohol_consumed,
                booking_id: bookingId,
                number_of_guests: bookingObject.number_of_guests,
                schedule: bookingObject.schedule
              }
            },
            ...(items || []).map((addOn) => ({
              type: 'ITEM',
              info: {
                item_id: addOn.item_id || addOn._id,
                max_count: addOn.count,
                ...(addOn.units && { count: addOn.units })
              }
            }))
          ]
        };;
        dispatch(guestUpdateQuote(quotePayload, bookingId, accessToken));
        dispatch(fetchInventory(bookingObject.space_id));
      });

      this.storeCardsData();
    }

    if ('add-ons' === updateStep || iosBrowseAddOns) {
      return dispatch(updateProgress(2));
    }

    dispatch(updateProgress(1));
  }

  componentDidUpdate (prevProps) {
    const prevProfileData = get(prevProps, 'profile.data', {});
    const profileData = get(this.props, 'profile.data', {});
    const accessToken = get(this.props, 'auth.accessToken');
    const paymentInfo = get(this.state, 'paymentInfo');

    if (isEmpty(prevProfileData) && !isEmpty(profileData) && accessToken && !paymentInfo) {
      this.storeCardsData();
    }
  }

  storeCardsData () {
    const SSOid = get(this.props, 'profile.SSOid', {});
    const accessToken = get(this.props, 'auth.accessToken');
    if (accessToken && SSOid) {
      this.fetchCardData((err, res) => {
        /**
         * If error occurs, we handle gracefully
         * and act as if there is no payment info on file,
         * still giving the user the option to fill out
         * new payment info.
         */

        let selectedPayment = false;
        let paymentInfo = [];

        if (res && Array.isArray(res) && 0 < res.length) {
          paymentInfo = res;
          selectedPayment = res[0];
        }

        this.setState({
          paymentInfo,
          selectedPayment
        });
      });
    }
  }

  componentWillReceiveProps (nextProps) {
    const { accessToken, profile } = nextProps;
    const { creditsFetched, creditsFetching } = this.state;

    // if user logs out, redirect to sign in
    if (!accessToken) {
      window.location.href = '/';
    }

    if (!creditsFetched && !creditsFetching && profile.SSOid) {
      this.setState({ creditsFetching: true })

      Profile.readCredits(profile.SSOid, accessToken, (response) => {
        if (200 === response.statusCode) {
          this.setState({ credits: response });
        }

        this.setState({ creditsFetched: true, creditsFetching: false })
      });
    }
  }

  componentWillUnmount () {
    const { dispatch } = this.props;

    Cookie.remove('booking_attendee_tier', { path: '/' });
    dispatch(resetProgress());
    dispatch(resetContractStore());
  }

  getCurrentSchedule () {
    const { scheduleValues, spaceRental } = this.props;
    const scheduleInPayload = scheduleValues;
    const bookingSchedule = get(spaceRental, 'meta.booking.schedule', []);

    const currentSchedule = bookingSchedule.map((hash) => {
      let returnVal;
      if (!isEmpty(hash)) {
        const date = hash.start.date;
        const day = moment(date.m + '-' + date.d + '-' + date.y, 'MM-DD-YYYY');
        if (day.isSameOrAfter(moment().startOf('day'))) {
          returnVal = hash;
        }
      }
      return returnVal;
    });

    // always prefer the payload schedule && filter for current dates
    const scheduleObj = !isEmpty(scheduleInPayload) ? scheduleInPayload : currentSchedule;
    const filteredSchedule = filter(scheduleObj, (sched) => { return !!sched; });
    const finalSchedule = filteredSchedule.length ? filteredSchedule : [{ }];

    return finalSchedule;
  }

  getFeeCalc (submitCallback, isDateChange, applyCreditChangeValue, suggestedCredit) {
    if (!submitCallback) {
      this.setState({
        showSkeleton: true
      });
    }

    const {
      dispatch,
      routeParams,
      applyCreditValue
    } = this.props;

    const { suggestedCreditAutoCalcCount } = this.state;
    const accessToken = PSSessions.Cookies('PSAccess');
    const schedule = this.getCurrentSchedule();

    if (!schedule.length || isEmpty(schedule[0])) {
      return this.loadBookingsTrack();
    }

    const payload = this.shapePayload(null, isDateChange, applyCreditChangeValue, suggestedCredit);

    return dispatch(guestUpdateQuote(payload, routeParams.id, accessToken, resp => {
      if (resp) {
        // If credits applied & quote total changes, BE provides suggested new credit amount - run fee calc again w/ suggested credit
        // Should only need to do this once. if for some reason BE comes back more than twice with suggested amounts error out to
        // avoid an infinite loop
        const applyCreditSelected = (applyCreditChangeValue || applyCreditValue).apply_credit;
        const suggestedCredit = get(resp, 'guest_payment_method_details.suggested');
        if (applyCreditSelected && suggestedCredit) {
          if (suggestedCreditAutoCalcCount > 1) {
            return this.setState({
              applyCreditProcessing: false,
              showSkeleton: false
            })
          }
          return this.setState({ suggestedCreditAutoCalcCount: suggestedCreditAutoCalcCount + 1 }, () => {
            this.getFeeCalc(null, false, null, suggestedCredit);
          })
        }
        this.setState({
          showSkeleton: false,
          applyCreditProcessing: false,
          suggestedCreditAutoCalcCount: 0
        });

        if (submitCallback) {
          submitCallback(get(resp, 'status'));
        }
      }
    }));
  }

  handleListClickCb (data, cb) {
    this.setState({
      selectedPayment: JSON.parse(data)
    }, cb);
  }

  paymentActionFn (datum) {
    this.setState(datum);
  }

  storeCardInstance (card, stripe) {
    this.setState({
      newCard: card,
      stripe
    });
  }

  createStripeToken (cardholders_name, cb) {
    const { newCard, stripe } = this.state;

    stripe.createToken(newCard, {
      name: cardholders_name
    }).then(cb);
  }

  fetchCardData (cb) {
    const { auth, profile } = this.props;
    const { SSOid } = profile;
    const { accessToken } = auth;

    Payments.getCustomerData(SSOid, accessToken, (res) => {
      if (400 === res.statusCode) {
        return cb(res.error);
      }

      return cb(false, res.data);
    });
  }

  shapePayload (alcoholConsumed, isDateChange, applyCreditChangeValue, suggestedCredit) {
    const { credits } = this.state;
    const {
      dispatch,
      numberGuestsValue = 0,
      attendeeTier,
      pendingContracts,
      addOnsValues,
      currentContracts,
      contract,
      isBrowseAddOns,
      spaceRental,
      hostAddOns,
      publicAddOns,
      applyCreditValue
    } = this.props;

    const { masterContract } = pendingContracts;
    const guestId = get(masterContract, 'guest_sso_id');
    const schedule = this.getCurrentSchedule();
    const hostId = get(masterContract, 'host_sso_id');
    const controlId = get(masterContract, 'control_id');
    // Add-ons that were added to the original booking which means they are active
    const activeAddOns = currentContracts.items || [];

    const activeAddOnsObj = keyBy(activeAddOns, (item) => {
      return item.item_id;
    });
    const schedObj = schedule[0].start.date;
    const oldSchedObj = get(spaceRental, 'meta.booking.schedule[0].start.date');
    const newBkgStart = moment(schedObj.m + '-' + schedObj.d + '-' + schedObj.y, 'MM-DD-YYYY');
    const oldBkgStart = moment(oldSchedObj.m + '-' + oldSchedObj.d + '-' + oldSchedObj.y, 'MM-DD-YYYY');

    const isOldDateConciergeValid = 2 <= business.weekDays(moment(), oldBkgStart);
    const isDateConciergeValid = 2 <= business.weekDays(moment(), newBkgStart);

    if (isDateConciergeValid !== isOldDateConciergeValid) {
      const dataToMap = isDateConciergeValid ? publicAddOns : hostAddOns;

      const addOns = map(dataToMap || [], (item) => {
        return {
          type: 'ITEM',
          info: {
            item_id: item.item_id || item._id,
            max_count: item.count,
            ...(item.units && { count: item.units })
          }
        };
      });

      dispatch(change(GUEST_UPDATE_BOOKING_FORM, 'addOns', addOns));
    }

    const selectedAddOns = getSelectedAddOns(currentContracts, addOnsValues);

    const handleDeletedAddOns = map(selectedAddOns, (addOn) => {
      if (activeAddOnsObj[addOn.info.item_id] && 0 === addOn.info.count) {
        return { ...addOn, info: { ...addOn.info, delete: true } };
      }

      if (0 === get(addOn, 'info.count')) {
        return null;
      }

      return addOn;
    });

    const emptyQuantityAddOns = map(activeAddOns, (addOn) => {
      const removedAddOn = find(selectedAddOns, (item) => {
        return item.info.item_id === (get(addOn, 'info.item_id') || get(addOn, 'item_id'));
      });

      if (!removedAddOn) {
       return {
         type: 'ITEM',
         info: {
           item_id: get(addOn, 'item_id'),
           count: 0,
           delete: true
         }
       }
     }

     return null;
    });

    const creditBalance = get(credits, 'balance', 0);
    // applyCreditChangeValue is passed here on apply credit change, otherwise look at applyCreditValue prop
    const applyCreditSelected = (applyCreditChangeValue || applyCreditValue).apply_credit;
    // suggestedCredit is passed here if BE provides credit suggestion, otherwise look at contract prop
    const suggestedCreditAmount = suggestedCredit ? get(suggestedCredit, 'subtotal_ps_credit') :
      get(contract, 'quote.guest_payment_method_details.suggested.subtotal_ps_credit')
      || get(contract, 'quote.guest_payment_method_details.subtotal_ps_credit');
    const creditToApply = 0 <= suggestedCreditAmount ? suggestedCreditAmount : creditBalance;
    const applyCreditAmount = applyCreditSelected ? creditToApply : 0;

    if (isBrowseAddOns) {
      return {
        host_sso_id: hostId,
        guest_sso_id: guestId,
        guest_payment_ps_credit_amount: applyCreditAmount,
        items: [
          ...compact(handleDeletedAddOns),
          ...compact(emptyQuantityAddOns)
        ]
      };
    }

    return {
      host_sso_id: hostId,
      guest_sso_id: guestId,
      guest_payment_ps_credit_amount: applyCreditAmount,
      items: [{
        type: 'BOOKING',
        info: {
          schedule,
          number_of_guests: numberGuestsValue || attendeeTier,
          booking_id: controlId,
          alcohol_consumed: alcoholConsumed
        }
      },
      ...compact(handleDeletedAddOns),
      ...compact(emptyQuantityAddOns)
      ]
    };
  }

  handleAttendeesChange (e) {
    const attendees = parseInt(e.target.value, 10);

    if (attendees) {
      this.getFeeCalc();
    }
  }

  handleBackClick (e) {
    e.preventDefault();
    const { dispatch, currentStep } = this.props;

    dispatch(updateProgress(currentStep - 1));
  }

  handleCancelClick (e) {
    e.preventDefault();
    const { dispatch, routeParams, iosWebView, closeIOSModal } = this.props;

    if (iosWebView) {
      return closeIOSModal();
    }

    const bookingId = get(routeParams, 'id');
    return dispatch(push(`/inbox/${bookingId}`));
  }

  handleAddOnChange (meetsMax) {
    if (meetsMax) {
      return this.getFeeCalc();
    }
  }

  handleApplyCreditChange (event, value) {
    this.setState ({ applyCreditProcessing: true });
    this.getFeeCalc(null, false, { apply_credit: value });
  }

  checkTransactability (user, cb) {
    if (!user || !this.props.accessToken) {
      location.hash = 'a=signup&source=msg';
    } else {
      this.setState({
        processing: true
      });
      const intendedAction = cb;

      // if transactable modal is X'd out, cancel spinning button
      const cancelProcessing = () => (
        this.setState({
          processing: false
        })
      );

      ReactDOM.render(
        <SharedIntlProviderHOC>
          <Transactable user={user} intendedAction={intendedAction} closeBehavior={cancelProcessing} />
        </SharedIntlProviderHOC>,
        document.getElementById('modal-container')
      );
    }
  }

  submitGuestUpdate (values, callback) {
    const {
      accessToken,
      spaceRental,
      contract,
      displayedAddOns,
      toggleModal,
      intl
    } = this.props;

    const { cardholders_name } = values;
    const { selectedPayment } = this.state;

    const listing = get(spaceRental, 'meta.listing', {});
    const bookingContracts = get(contract, 'quote.pending.children', []);

    bookingContracts.push(get(contract, 'quote.pending.master', {}));
    analyticsIntegrations.messageTrack('guest update form submitted', listing, bookingContracts, {}, displayedAddOns);

    const payload = this.shapePayload(get(values, 'alcohol_consumed', null));

    // Check transactability
    Profile.read('/v1/profiles/me', accessToken, (user) => {
      this.checkTransactability(user, () => {
        if (selectedPayment) {
          // existing card
          payload.guest_payment_card_id = selectedPayment.id;
          payload.guest_payment_customer_id = selectedPayment.customer;

          // post booking request
          return callback(false, payload);
        }

        // create new token
        return this.createStripeToken(cardholders_name, (tokenRes) => {
          if (tokenRes.error) {
            this.setState({ processing: false });
            return toggleModal('paymentErrorModal', tokenRes.error.message);
          }

          // new card token
          const { token } = tokenRes;
          const cardToken = token.id;
          const ssoid = get(user, 'SSOid', '');

          // add card to Payments API.
          const locale = SharedIntlProviderHOC.getLocale();
          return Payments.addCard(locale, ssoid, accessToken, cardToken, (res) => {
            if (res.error || 400 < res.statusCode) {
              const errorHead = res.error.errorCode
                  ? intl.formatMessage(paymentErrors[res.error.errorCode])
                  : res.error.message;

              const apiError = res.error.errorCode && intl.formatMessage(paymentErrors[res.error.errorCode]);
              const stripeRawErr = get(res, 'error.raw.code', null);
              const stripeRawDeclineErr = get(res, 'error.raw.decline_code', null);
              const stripeErrObj = stripeRawDeclineErr || stripeRawErr ? stripeErrorHandler(stripeRawDeclineErr || stripeRawErr) : null;
              const stripeRawMsg = stripeErrObj ? intl.formatMessage({ ...stripeErrObj }) : null;
              const errorBody = apiError || stripeRawMsg || null

              const errorMessage = { errorHead: errorHead,  errorBody: errorBody }
              this.setState({ processing: false });
              return toggleModal('paymentErrorModal', errorMessage);
            }

            payload.guest_payment_card_id = res.id;
            payload.guest_payment_customer_id = res.customer;

            // card added, post booking request
            return callback(false, payload);
          });
        });
      });
    });
  }

  submitCallback (response) {
    const {
      iosWebView,
      closeIOSModal,
      finalCb,
      accessToken,
      routeParams,
      bookingID,
      pendingContracts,
      contract
    } = this.props;

    const bookingId = get(routeParams, 'id') || bookingID;
    const priceBreakdown = priceBreakdownObject(pendingContracts);
    const additionalCharge = 0 < get(priceBreakdown, 'updateDifference.additional_payment', 0);
    const paymentRequired = !!(additionalCharge || contract?.quote?.remaining_sp_payment_required);

    this.setState({
      processing: false,
      ccProcessing: paymentRequired,
      priceBreakdown: priceBreakdown
    });

    if (!response.error) {
      if (paymentRequired) {
        return checkCCStateInterval(bookingId, accessToken, this.ccProcessingCb);
      }

      if (iosWebView) {
        closeIOSModal();
        return finalCb();
      }

      return this.context.router.push({ pathname: `/inbox/${bookingId}` });
    }

    return this.setState({ errorText: this.props.intl.formatMessage({ id: 'inbox_guest_update_booking.update_booking_container.something_wrong', defaultMessage: 'Something went wrong, please try again.' }) });
  }

  ccProcessingCb () {
    const { routeParams, bookingID, iosWebView, closeIOSModal, finalCb } = this.props;
    const bookingId = get(routeParams, 'id') || bookingID;

    if (iosWebView) {
      closeIOSModal();
      return finalCb();
    }

    return this.context.router.push({ pathname: `/inbox/${bookingId}` });
  }

  handleBreadcrumbClick (step) {
    const { dispatch } = this.props;
    dispatch(updateProgress(step));
  }

  render () {
    const {
      profile,
      spaceRental = [],
      initialValues = {},
      currentStep,
      routeParams,
      whichModalCb
    } = this.props;

    const {
      paymentInfo,
      selectedPayment,
      processing,
      errorText,
      ccProcessing,
      credits,
      creditsFetched,
      applyCreditProcessing
    } = this.state;
    const controlId = get(routeParams, 'id');
    const fetchedProfile = !isEmpty(profile.data);
    const fetchedBooking = !isEmpty(spaceRental);
    const fetchedAddOns = !isEmpty(get(this.props, 'inventory.data'));
    const spaceId = get(spaceRental, 'meta.booking.space_id');

    const showAddOns = !!initialValues.addOns.length;

    return (
      <SharedIntlProviderHOC>
        <div className="UpdateBookingContainer">
          {
            ccProcessing ?
            <ProcessingPage />
            :
            fetchedProfile && fetchedBooking && fetchedAddOns && currentStep && creditsFetched ?
              <UpdateBookingGuestMain
                maxAttendees={get(spaceRental, 'meta.listing.number_guests')}
                spaceId={spaceId}
                schedule={this.getCurrentSchedule()}
                getFeeCalc={this.getFeeCalc}
                submitGuestUpdate={this.submitGuestUpdate}
                handleAttendeesChange={this.handleAttendeesChange}
                handleAddOnChange={this.handleAddOnChange}
                showSkeleton={this.state.showSkeleton}
                handleCancelClick={this.handleCancelClick}
                handleBackClick={this.handleBackClick}
                showAddOns={showAddOns}
                paymentInfo={paymentInfo}
                selectedPayment={selectedPayment}
                paymentActionFn={this.paymentActionFn}
                storeCardInstance={this.storeCardInstance}
                handleListClickCb={this.handleListClickCb}
                submitCallback={this.submitCallback}
                controlId={controlId}
                processing={processing}
                paymentErrorMsg={whichModalCb}
                errorText={errorText}
                credits={credits}
                handleApplyCreditChange={this.handleApplyCreditChange}
                applyCreditProcessing={applyCreditProcessing}
                handleBreadcrumbClick={this.handleBreadcrumbClick}
                {...this.props}
              />
              :
              <div className="spinner-container">
                <PageSpinner />
              </div>
          }
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

UpdateBookingContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  routeParams: PropTypes.object,
  iosBrowseAddOns: PropTypes.bool,
  contract: PropTypes.object,
  currentContracts: normalizedContractsShape,
  pendingContracts: normalizedContractsShape,
  intl: intlShape
};

UpdateBookingContainer.contextTypes = {
  router: PropTypes.object
};

const selector = formValueSelector(GUEST_UPDATE_BOOKING_FORM);

function mapStateToProps (state, ownProps) {
  const { auth, profile, contract, inventory, flow } = state;
  const isBrowseAddOns = 'add-ons' === get(ownProps.routeParams, 'step') || ownProps.iosBrowseAddOns;
  const currentStep = get(flow, 'step', null);
  const scheduleValues = selector(state, 'schedule');
  const numberGuestsValue = selector(state, 'number_of_guests');
  const alcoholConsumed = selector(state, 'alcohol_consumed');
  const addOnsValues = selector(state, 'addOns', []);
  const applyCreditValue = selector(state, 'apply_credit', {});

  const { quote } = contract;
  const currentContracts = quote?.contracts || [];
  const spaceRentalContract = currentContracts.find(
    (c) => c.type === 'SPACE_RENTAL'
  );
  const normalizedCurrentContracts = normalizeContracts(
    currentContracts,
    spaceRentalContract,
    quote?.guest_payment_method_details
  );
  const pendingContracts = quote?.pending || {};
  const normalizedPendingContracts = normalizeContracts(
    pendingContracts,
    spaceRentalContract,
    quote?.guest_payment_method_details
  );

  const contractQuoteConflict = get(contract, 'quoteErrors[0].conflict', '');
  const contractQuoteInvalid = get(contract, 'quoteErrors[0].invalid', '');
  const contractQuoteError = contractQuoteConflict || contractQuoteInvalid;
  const finalSchedule = get(
    normalizedPendingContracts,
    'bookingObject.schedule'
  );
  const inventoryData = get(inventory, 'data.inventory', []);
  const displayedAddOns = filter(inventoryData, { visible_on_listing: true }) || [];
  const attendeeTier = Cookie.load('booking_attendee_tier');
  const addedHiddenAddOns = compact(map(get(contract, 'quote.contracts', []) || get(contract, 'quote.pending.children'), (obj) => {
    if (('ITEM' === obj.type) && (false === obj.meta.visible_on_listing)) {
      return obj.meta;
    }
  }));

  const publicAddOns = map(
    isBrowseAddOns ? [...inventoryData, ...addedHiddenAddOns] : inventoryData,
    (addOn) => {
      const addedItem = find(normalizedPendingContracts.items, {
        item_id: addOn.item_id || addOn._id
      });

      if (addedItem) {
        return {
          ...addedItem.meta,
          units: addedItem.units
        };
      }

      return addOn;
    }
  );

  const bkgSchedObj = get(normalizedPendingContracts, 'bookingObject.schedule[0].start.date', {});
  const bookingStart = moment(bkgSchedObj.m + '-' + bkgSchedObj.d + '-' + bkgSchedObj.y, 'MM-DD-YYYY');
  // show concierge items if booking is within 2 business days
  const showConciergeItems = 2 <= business.weekDays( moment(), bookingStart );
  const hostAddOns = filter(publicAddOns, (addOn) => {
    return !addOn.is_concierge;
  });

  const displayAddOns = showConciergeItems ? publicAddOns : hostAddOns;
  const addOns = map(displayAddOns || [], (item) => {
    return {
      type: 'ITEM',
      info: {
        item_id: item.item_id || item._id,
        max_count: item.count,
        ...(item.units && { count: item.units })
      }
    };
  });

  const {
    isFetching
  } = profile || {
    isFetching: true
  };

  return {
    auth,
    profile,
    isFetching,
    inventory,
    currentStep,
    spaceRental: normalizedPendingContracts.spaceRentalContract,
    contract,
    initialValues: {
      scheduleInput: getInitialScheduleVals(finalSchedule),
      schedule: finalSchedule,
      addOns,
      alcohol_consumed: `${get(
        normalizedPendingContracts,
        'bookingObject.alcohol_consumed',
        false
      )}`,
      number_of_guests:
        numberGuestsValue ||
        get(normalizedPendingContracts, 'bookingObject.number_of_guests'),
      apply_credit: false
    },
    scheduleValues,
    numberGuestsValue,
    addOnsContracts: normalizedPendingContracts.items,
    addOnsValues: addOnsValues.addOns,
    applyCreditValue: applyCreditValue,
    contractQuoteError,
    publicAddOns,
    displayAddOns,
    hostAddOns,
    displayedAddOns,
    currentContracts: normalizedCurrentContracts,
    pendingContracts: normalizedPendingContracts,
    attendeeTier,
    isBrowseAddOns,
    alcoholConsumed
  };
}

export default injectIntl(connect(mapStateToProps)(UpdateBookingContainer));
